(function () {
  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }

  function setActiveLink(itemsById, activeId) {
    Object.keys(itemsById).forEach(function (id) {
      itemsById[id].link.classList.toggle("is-active", id === activeId);
      itemsById[id].item.classList.remove("is-expanded");
    });

    var activeItem = itemsById[activeId];
    if (!activeItem) {
      return;
    }

    var currentItem = activeItem.item;
    while (currentItem && currentItem.matches("li")) {
      currentItem.classList.add("is-expanded");
      var parentListItem = currentItem.parentElement.closest("li");
      currentItem = parentListItem;
    }
  }

  function getCssVariableValue(varName) {
    var bodyStyles = window.getComputedStyle(document.body);
    var bodyValue = parseFloat(bodyStyles.getPropertyValue(varName));
    if (!Number.isNaN(bodyValue) && bodyValue > 0) {
      return bodyValue;
    }

    var rootStyles = window.getComputedStyle(document.documentElement);
    var rootValue = parseFloat(rootStyles.getPropertyValue(varName));
    if (!Number.isNaN(rootValue) && rootValue > 0) {
      return rootValue;
    }

    return 0;
  }

  function getTocOffset() {
    var offsetVariable = document.body.classList.contains("header-pinned")
      ? "--header-height"
      : "--header-group-height";

    return getCssVariableValue(offsetVariable) + 20;
  }

  function getHeadings(container) {
    var preferredHeadings = Array.prototype.slice.call(
      container.querySelectorAll("h2, h3, h4")
    );

    if (preferredHeadings.length > 0) {
      return preferredHeadings;
    }

    return Array.prototype.slice.call(
      container.querySelectorAll("h1, h2, h3, h4, h5, h6")
    );
  }

  function ensureHeadingIds(headings) {
    var usedIds = {};

    headings.forEach(function (heading, index) {
      var baseId = heading.id || slugify(heading.textContent) || "section-" + (index + 1);
      var uniqueId = baseId;
      var duplicateIndex = 2;

      while (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading) {
        uniqueId = baseId + "-" + duplicateIndex;
        duplicateIndex += 1;
      }

      while (usedIds[uniqueId]) {
        uniqueId = baseId + "-" + duplicateIndex;
        duplicateIndex += 1;
      }

      usedIds[uniqueId] = true;
      heading.id = uniqueId;
    });
  }

  function buildNestedTocList(headings, list) {
    list.innerHTML = "";

    if (!headings.length) {
      return;
    }

    var itemsById = {};
    var baseLevel = headings.reduce(function (min, heading) {
      var lvl = parseInt(heading.tagName.slice(1), 10);
      return lvl < min ? lvl : min;
    }, 6);
    var stack = [{ level: baseLevel, list: list, index: 0 }];

    headings.forEach(function (heading) {
      var headingLevel = parseInt(heading.tagName.slice(1), 10);

      while (stack.length > 1 && headingLevel < stack[stack.length - 1].level) {
        stack.pop();
      }

      if (headingLevel > stack[stack.length - 1].level) {
        var parentList = stack[stack.length - 1].list;
        var parentItem = parentList.lastElementChild;

        if (parentItem) {
          var nestedList = document.createElement("ol");
          parentItem.appendChild(nestedList);
          stack.push({ level: headingLevel, list: nestedList, index: 0 });
        }
      }

      stack[stack.length - 1].index += 1;
      var itemNumber = stack
        .map(function (entry) {
          return entry.index;
        })
        .join(".")
        .concat(".");

      var listItem = document.createElement("li");
      var link = document.createElement("a");
      var number = document.createElement("span");
      var text = document.createElement("span");
      listItem.className = "toc-content__item";
      link.className = "toc-content__link";
      link.href = "#" + heading.id;
      number.className = "toc-content__number";
      number.textContent = itemNumber;
      text.className = "toc-content__text";
      text.textContent = heading.textContent.trim();
      link.appendChild(number);
      link.appendChild(text);

      link.addEventListener("click", function (event) {
        event.preventDefault();
        var scrollOffset = getTocOffset();
        var headingTop = heading.getBoundingClientRect().top + window.scrollY - scrollOffset;
        window.scrollTo({ top: Math.max(headingTop, 0), behavior: "smooth" });
        window.history.replaceState(null, "", "#" + heading.id);
      });

      listItem.appendChild(link);
      stack[stack.length - 1].list.appendChild(listItem);
      itemsById[heading.id] = {
        link: link,
        item: listItem
      };
    });

    return itemsById;
  }

  function initTocSection(section) {
    if (section.dataset.tocInitialized === "true") {
      return;
    }

    var menu = section.querySelector("[data-toc-menu]");
    var tocList = section.querySelector("[data-toc-list]");
    var content = section.querySelector("[data-toc-content]");
    var backToTopButton = section.querySelector("[data-toc-back-to-top]");

    if (!menu || !tocList || !content) {
      return;
    }

    if (backToTopButton) {
      backToTopButton.addEventListener("click", function (event) {
        event.preventDefault();
        var sectionTop = section.getBoundingClientRect().top + window.scrollY - getTocOffset();
        window.scrollTo({ top: Math.max(sectionTop, 0), behavior: "smooth" });
      });
    }

    var extra = section.querySelector("[data-toc-extra]");
    var headings = getHeadings(content);
    if (extra) {
      headings = headings.concat(getHeadings(extra));
    }

    if (headings.length < 2) {
      menu.style.display = "none";
      section.dataset.tocInitialized = "true";
      return;
    }

    ensureHeadingIds(headings);
    var itemsById = buildNestedTocList(headings, tocList);
    var ticking = false;

    function syncTocOffset() {
      section.style.setProperty("--toc-scroll-offset", getTocOffset() + "px");
    }

    function updateActiveHeading() {
      var activeId = headings[0].id;
      var threshold = getTocOffset() + window.innerHeight * 0.2;

      headings.forEach(function (heading) {
        if (heading.getBoundingClientRect().top - threshold <= 0) {
          activeId = heading.id;
        }
      });

      setActiveLink(itemsById, activeId);
    }

    function requestTick() {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function () {
        syncTocOffset();
        updateActiveHeading();
        ticking = false;
      });
    }

    syncTocOffset();
    updateActiveHeading();
    window.addEventListener("scroll", requestTick, { passive: true });
    window.addEventListener("resize", requestTick);
    section.dataset.tocInitialized = "true";
  }

  function initAllTocSections() {
    var sections = document.querySelectorAll("[data-toc-section]");
    sections.forEach(initTocSection);
  }

  document.addEventListener("DOMContentLoaded", initAllTocSections);
  document.addEventListener("shopify:section:load", initAllTocSections);
})();
